import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { ArrowUpRight } from "lucide-react";
import featured_book_1 from "../assets/featured_books/featured_book_1.png";
import featured_book_2 from "../assets/featured_books/featured_book_2.png";
import featured_book_3 from "../assets/featured_books/featured_book_3.png";
import featured_book_4 from "../assets/featured_books/featured_book_4.png";
import featured_book_5 from "../assets/featured_books/featured_book_5.png";
import featured_book_6 from "../assets/featured_books/featured_book_6.png";
import { useI18n } from "../i18n/I18nProvider";

export default function FeaturedBooksSection() {
  const books = [
    featured_book_1,
    featured_book_2,
    featured_book_3,
    featured_book_4,
    featured_book_5,
    featured_book_6,
  ];
  const exploreUrl = "https://ekatra-summarizer.glide.page/dl/ceb417";
  const { t } = useI18n();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <section
      id="books"
      className={`w-full text-center overflow-hidden ${isMobile ? "py-2 md:py-12" : "py-20 md:py-12"}`}
    >
      <div className="w-full flex justify-center px-4 sm:px-10">
        <div className="w-full max-w-6xl overflow-hidden">
          <div className="h-[450px] md:h-[450px] lg:h-[450px] relative">
            <Swiper
              className="featured-swiper"
              modules={[Autoplay, EffectCoverflow]}
              effect="coverflow"
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={3}
              spaceBetween={-350}
              loop={true}
              loopedSlides={books.length}
              speed={600}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
              }}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 180,
                modifier: 1,
                slideShadows: false,
              }}
              onSwiper={(swiper) => {
                const middle = Math.floor(books.length / 2);
                swiper.slideToLoop(middle, 0);
                 setTimeout(() => {
                  swiper.autoplay.start();
                }, 100);
              }}
            >
              {books.map((src, index) => (
                <SwiperSlide key={index}>
                  {({ isActive, isPrev, isNext }) => (
                    <div className="w-full h-full flex items-center justify-center">
                      <img
                        src={src}
                        alt={`Featured ${index}`}
                        className="slide-img transition-all duration-500 rounded-[1.3rem]"
                        draggable="false"
                        style={{
                          width: isActive
                            ? "320px"
                            : isPrev || isNext
                            ? "280px"
                            : "240px",
                          height: isActive
                            ? "auto"
                            : isPrev || isNext
                            ? "auto"
                            : "auto",
                          objectFit: "contain",
                          transform: isActive ? "scale(1.05)" : "scale(1)",
                        }}
                      />
                    </div>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      <div className="mt-8 flex justify-center items-center gap-0">
        <a
          href={exploreUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 px-8 py-3 bg-ekatraOrange text-white rounded-full text-lg font-semibold shadow-md hover:bg-ekatraOrange/80 transition"
        >
          {t("featuredBooks.cta")}
        </a>
        <a
          href={exploreUrl}
          target="_blank"
          rel="noreferrer"
          className="relative left-[-8px] w-[52px] h-[52px] bg-ekatraOrange text-white rounded-full shadow-md flex items-center justify-center hover:bg-ekatraOrange/80 transition"
          aria-label="Open Explore More in a new tab"
        >
          <ArrowUpRight size={22} strokeWidth={2} />
        </a>
      </div>
    </section>
  );
}
